module.exports = (__webpack_require__(0))(48);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/HierarchyWidget.js from dll-reference girder_lib
// module id = 215
// module chunks = 0